import { withInstall } from '@tav-ui/utils/with-install'
import Tree from './src/tree'
const TaTree = withInstall(Tree)
export { TaTree }
export default TaTree
export * from './src/props'
